'use client';

import React from 'react';
import { LogoImg } from '@ianesthesie-kit/common-pages';
import LogoHoopCareLarge from '../../../public/logo/logo_hoopcare.svg';
import { Box, BoxProps } from '@mui/material';

// const SecondLogoContainer = styled('div')`
//   position: absolute;
//   width: 45px;
//   height: 45px;
//   left: 80%;
//   top: 50%;
//   z-index: 999;
//   background: white;
//   border-radius: 999px;
//   border: ${(p) => `3px solid ${p.theme.palette.primary.light}`};
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   overflow: hidden;
//
//   & > img {
//     display: inline-block;
//     object-fit: contain;
//     max-width: 65%;
//     max-height: 65%;
//   }
//   & div {
//     height: 100%;
//   }
// `;

type HoopCareLogoProps = BoxProps;

export const HoopCareLogo = (props: HoopCareLogoProps) => (
  <Box
    sx={{
      position: 'relative',
      width: 140,
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      '& img': {
        objectFit: 'contain'
      }
    }}
    {...props}
  >
    <LogoImg src={LogoHoopCareLarge} />
    {/*{secondaryLogo && (*/}
    {/*  <SecondLogoContainer>*/}
    {/*    <img src={secondaryLogo.path} />{' '}*/}
    {/*    /!* TODO FIXME change to Nextjs Image *!/*/}
    {/*  </SecondLogoContainer>*/}
    {/*)}*/}
  </Box>
);
